import { updateTFIDBPageJSONService } from '../../Graphql/mutations'
import AppSyncClient from '../../Utils/AppSyncClient'
const updateTFIDBPageJSONMutation = async parameters => {
  try {
    const data = await AppSyncClient.mutate({
      mutation: updateTFIDBPageJSONService,
      variables: parameters,
      fetchPolicy: 'no-cache',
    })
    return data
  } catch (error) {
    return error
  }
}

export default updateTFIDBPageJSONMutation
